import * as ng from 'angular';

ng.module('e360').directive('draggable', function() {
   return {
      restrict: 'A',
      link: draggableLinkFn,
      scope: {
         onDragStart: '&',
         onDragStop: '&'
      }
   };
});

function draggableLinkFn(scope, element:JQLite, attrs:ng.IAttributes) {
   if (attrs['draggable'] !== 'true') {
      return;
   }

   element.on('dragstart', onDragStart);
   element.on('dragover', onDragOver);
   element.on('drop', onDragDrop);

   function onDragStart(e:JQueryEventObject) {
      (e.originalEvent as DragEvent).dataTransfer.setData('application/e360', scope.onDragStart());
   }

   function onDragOver(e:JQueryEventObject) {
      // ignore other sources of dragging (e.g. text drag/drop)
      if ((e.originalEvent as DragEvent).dataTransfer.types.indexOf('application/e360') >= 0) {
         e.preventDefault();
      }
   }

   function onDragDrop(e:JQueryEventObject) {
      let data = (e.originalEvent as DragEvent).dataTransfer.getData('application/e360');
      scope.$apply(() => scope.onDragStop({$event: e, $data: data}));
      e.preventDefault();
   }
}
